<script>
export default {
  name: 'ConfirmStopLive',

  data () {
    return {
      isLoading: false
    }
  },

  methods: {
    handleCloseDialog () {
      this.$emit('close')
      this.$emit('update:dialogVisible', false)
    },
    submit () {
      this.isLoading = true
      this.$emit('submit')
    }
  }
}
</script>

<template lang="pug" src="./ConfirmStopLive.pug"></template>
